import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function Header({ onToggleSidebar }) {
  const handleLocked = (e) => {
    e.preventDefault();
    toast.error("Please deposit funds to access this page");
  };

  return (
    <div className="app-header header sticky">
      <div className="container-fluid main-container">
        <div className="d-flex align-items-center">
          <button className="app-sidebar__toggle" aria-label="Hide Sidebar" onClick={onToggleSidebar} />
          <Link className="logo-horizontal" to="/wallet">
            <p className="title-header-p">PatrickStash</p>
          </Link>
          <div className="d-flex order-lg-2 ms-auto header-right-icons">
            <div className="d-flex align-items-center px-2">
              <a
                href="https://t.me/+OjIIH9ZKyuYzN2Ix"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-info label-btn rounded-pill d-flex align-items-center"
              >
                <i className="ri-telegram-line me-2 rounded-pill" style={{ fontSize: 17 }}></i>
                updates channel
              </a>
            </div>
            <div className="d-md-flex">
              <Link to="/wallet" className="nav-link pe-2 leading-none d-flex animate">
                <span>
                  <i className="mdi mdi-currency-usd"></i>
                </span>
                <div className="text-center p-1 d-flex d-lg-none-max">
                  <h6 className="mb-0" id="profile-heading">0</h6>
                </div>
              </Link>
            </div>
            <div className="d-md-flex">
              <a href="#nav" className="nav-link pe-2 leading-none d-flex animate" onClick={handleLocked}>
                <span>
                  <i className="mdi mdi-arrow-up-thick"></i>
                </span>
                <div className="text-center p-1 d-flex d-lg-none-max">
                  <h6 className="mb-0" id="profile-heading">0 LVL</h6>
                </div>
              </a>
            </div>
            <div className="d-md-flex">
              <a href="#nav" className="nav-link pe-2 leading-none d-flex animate" onClick={handleLocked}>
                <div className="text-center p-1 d-flex d-lg-none-max">
                  <h6 className="mb-0" id="profile-heading">0 Points</h6>
                </div>
              </a>
            </div>
            <div className="d-md-flex">
              <Link to="/tickets" className="nav-link pe-2 leading-none d-flex animate" onClick={handleLocked}>
                <span>
                  <i className="fa fa-life-ring"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
